import { FC, memo } from "react";

const SideUsers: FC = () => {
    return (
        <section className="aside-body__users users">
            <div className="users__circle">
                <div className="users__percents">+26%</div>
                <div className="users__line">
                    <svg
                        width="66"
                        height="121"
                        viewBox="0 0 66 121"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M6.19285 120.323C5.42324 120.336 4.65903 120.192 3.94559 119.901C3.23216 119.61 2.58407 119.177 2.0398 118.629C1.49554 118.081 1.06621 117.428 0.777331 116.709C0.488447 115.99 0.345899 115.22 0.35815 114.445C0.357189 112.865 0.965082 111.347 2.05361 110.211C3.14215 109.074 4.62623 108.408 6.19285 108.353C17.5671 108.279 28.559 104.207 37.2709 96.8386C44.6801 90.4092 49.9726 81.8608 52.4457 72.3289C54.9188 62.797 54.4554 52.7326 51.117 43.4723C47.6614 34.2656 41.52 26.329 33.5011 20.7071C25.4822 15.0851 15.9618 12.0414 6.19285 11.9764C5.15691 11.9746 4.14075 11.6905 3.25197 11.1543C2.36319 10.6181 1.63488 9.84963 1.14417 8.93038C0.633389 7.99762 0.365496 6.94967 0.365496 5.88436C0.365496 4.81904 0.633389 3.77109 1.14417 2.83833C1.6623 1.93821 2.41525 1.19829 3.32128 0.69889C4.22731 0.19949 5.2518 -0.0403071 6.28355 0.00553039C15.9225 0.0143815 25.4161 2.3744 33.953 6.88391C42.4899 11.3934 49.8163 17.9184 55.3062 25.9011C60.796 33.8839 64.2861 43.0872 65.4782 52.7246C66.6702 62.3619 65.5289 72.1468 62.1515 81.243C57.776 92.6326 50.1165 102.442 40.1595 109.407C30.2025 116.372 18.404 120.174 6.28355 120.323H6.19285Z"
                            fill="#0FAFE9"
                        />
                    </svg>
                </div>
            </div>
            <h5 className="users__title">Monthly users in your site</h5>
            <div className="users__number">1.0286</div>
            <p className="users__text">We accompany you with our versatile expertise in digital marketing</p>
        </section>
    );
};

export default memo(SideUsers);
